module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app",
      "lang": _vm.language
    }
  }, [_c('book', {
    staticClass: "book",
    attrs: {
      "data": _vm.pages,
      "startPageIndex": 1,
      "showPageIndex": false,
      "endPageIndex": _vm.pages.length - 2,
      "color": _vm.color,
      "width": _vm.width,
      "height": _vm.height
    },
    on: {
      "next": _vm.pageChange,
      "prev": _vm.pageChange,
      "indexPageChange": _vm.indexPageChange,
      "atFirstPage": _vm.atFirstPage,
      "atEndPage": _vm.atEndPage,
      "swipeLeft": _vm.swipeLeft,
      "swipeRight": _vm.swipeRight,
      "audioEnded": _vm.audioEnded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('img', {
          attrs: {
            "src": prop.page.url,
            "alt": prop.page.alt
          }
        }), _vm._v(" "), _c('p', [_vm._v(_vm._s(prop.page.title))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-577d49ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 36
// module chunks = 0